

<mat-divider></mat-divider>

<div class="sidebar-content">
  <mat-nav-list>
    <div mat-subheader class="subheader-spacing">
      Studio Pulse Partners
    </div>
    <ng-container *ngFor="let Partner of partner">
      <a mat-list-item 
         [routerLink]="['/partner', Partner.name]" 
         routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: false }"
         class="always-active">
        <span matListItemIcon><img class="dark:invert" src="assets/{{ Partner.name }}.png" alt=""
            height="24" width="24" /></span>
        <div matListItemTitle>{{ Partner.name | titlecase }}</div>
      </a>
    </ng-container>

    <mat-divider></mat-divider>

  </mat-nav-list>
</div>

<div class="absolute bottom-0 w-full">
  <mat-divider></mat-divider>

  <div class="relative m-4 flex justify-between">

  </div>
</div>

<ng-template #loading>
  <div class="flex h-14 w-full items-center justify-center">
    <mat-progress-spinner diameter="25" mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>
